import { useEffect, useRef, useState, forwardRef, useImperativeHandle } from 'react';

import 'altcha';


const Altcha = forwardRef(({ onStateChange }, ref) => {
  const widgetRef = useRef(null);
  const [value, setValue] = useState(null);

  useImperativeHandle(ref, () => {
    return {
      get value() {
        return value;
      }
    };
  }, [value]);

  useEffect(() => {
    const handleStateChange = (ev) => {
      if ('detail' in ev) {
        setValue(ev.detail.payload || null);
        onStateChange?.(ev);
      }
    };

    const { current } = widgetRef;

    if (current) {
      current.addEventListener('statechange', handleStateChange);
      return () => current.removeEventListener('statechange', handleStateChange);
    }
  }, [onStateChange]);

  return (
    <altcha-widget
      ref={widgetRef}
      style={{
        // '--altcha-max-width': '100%',
      }}
      auto="onfocus"
      challengejson={JSON.stringify({
        algorithm: 'SHA-256',
        challenge: '8a31a8016544027355d118cf4081bae835925882dff1f8c02f576f2115cd5d7c',
        maxnumber: 310000,
        salt: '7e51b05805ce24c0c03b653e',
        signature: '587804b3afa1282a29b423611d0670a9f8d540b176c3fa1c7000d9289eebea7c'
      })}
    ></altcha-widget>
  );
});

export default Altcha;
